import { FaLinkedin, FaFacebook, FaTwitter } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import mslLogo from "../assets/msllogo.png";
import { useState } from "react";
import SecurityAlert from "./SecurityAlert";

const Footer = () => {
  const [showSecurityAlert, setShowSecurityAlert] = useState(false);
  const navigate = useNavigate();

  const handleRepayClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowSecurityAlert(true);
  };

  const handleSecurityConfirm = () => {
    setShowSecurityAlert(false);
    navigate('/repay');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <SecurityAlert 
        isOpen={showSecurityAlert}
        onClose={() => setShowSecurityAlert(false)}
        onConfirm={handleSecurityConfirm}
      />
    <footer className="w-full bg-white border-t border-gray-200 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-[#2C3E50] mb-4 font-['Inter']">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Home</Link></li>
              <li><Link to="/about" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">About Us</Link></li>
              <li><a href={import.meta.env.VITE_WEBSITE_LINK} target="_blank" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Apply Now</a></li>
              <li><a href="/repay" onClick={handleRepayClick} className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Repay Loan</a></li>
              <li><Link to="/faq" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">FAQ's</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Contact Us</Link></li>
            </ul>
          </div>

          {/* Legal & Policies */}
          <div>
            <h3 className="text-lg font-bold text-[#2C3E50] mb-4 font-['Inter']">Legal & Policies</h3>
            <ul className="space-y-3">
              <li><Link to="/corporate-governance" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Corporate Governance</Link></li>
              <li><Link to="/fair-practice-code" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Fair Practice Code</Link></li>
              <li><Link to="/risk-management-policy" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Risk Management</Link></li>
              <li><Link to="/interest-rate-policy" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Interest Rate Policy</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Privacy Policy</Link></li>
              <li><Link to="/terms-condition" className="text-gray-600 hover:text-[#21A6B5] transition-colors font-['Inter']">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-lg font-bold text-[#2C3E50] mb-4 font-['Inter']">Contact Us</h3>
            <div className="space-y-3 text-gray-600 font-['Inter']">
              <p className="font-semibold text-[#2C3E50]">About us</p>
              <p>{import.meta.env.VITE_COMPANY_PHONE || "+91 9717121872"}</p>
             <p>{import.meta.env. VITE_COMPANY_EMAIL}</p>
              <p className="text-sm leading-relaxed">
                {import.meta.env.VITE_COMPANY_ADDRESS}
              </p>
            </div>
          </div>

          {/* Grievance Redressal */}
          <div>
           
            <div className="space-y-4 text-l font-['Inter']">

              <div>
                <p className="font-semibold text-[#2C3E50] mb-1">Grievance Officer</p>
              
                <p className="text-gray-500">📞 {import.meta.env.VITE_BRAND_GRIEVANCE_OFFICER_PHONE}</p>
                <p className="text-gray-500">✉️ {import.meta.env.VITE_BRAND_GRIEVANCE_OFFICER_EMAIL}</p>
              </div>

              <div className="border-t border-gray-100 pt-3">
                <p className="font-semibold text-[#2C3E50] mb-1">Nodal Officer</p>
               
                <p className="text-gray-500">📞 {import.meta.env.VITE_BRAND_NODAL_OFFICER_PHONE}</p>
                <p className="text-gray-500">✉️ {import.meta.env.VITE_BRAND_NODAL_OFFICER_EMAIL}</p>
              </div>

            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            
            {/* Logo - Left */}
            <div className="flex-shrink-0">
              <img src={mslLogo} alt="MySalaryLoan" className="h-10" />
            </div>

            {/* Copyright and NBFC Info - Center */}
            <div className="flex-1 text-center">
              <div className="flex items-center justify-center gap-3 mb-3">
                <p className="text-sm font-bold text-[#2C3E50] font-['Inter']">
                  NBFC Partner:
                </p>
                <p className="text-sm text-gray-600 font-['Inter']">
                  {import.meta.env.VITE_COMPANY_NBFC}
                </p>   
              </div>
              <p className="text-sm font-bold text-[#2C3E50] font-['Inter']">
                  Powered By:{" "}
                  <a
                    href="https://fintechcloud.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#21A6B5] hover:underline"
                  >
                    Fintech Cloud Private Limited
                  </a>
                </p>
              
              <div className="flex items-center justify-center gap-3 mb-3">
                <p className="text-sm font-bold text-[#2C3E50] font-['Inter']">
                  RBI NBFC License:
                </p>
                <div className="bg-gradient-to-r from-[#21A6B5] to-[#1B8E9B] text-white px-4 py-1.5 rounded-full text-sm font-semibold">
                  {import.meta.env.VITE_COMPANY_NBFC_LICENSE}
                </div>
               
              </div>
              
              <p className="text-sm text-gray-600 font-['Inter'] mt-3">© 2025 MySalaryLoan All Rights Reserved.</p>
              <p className="text-xs text-gray-500 font-['Inter'] mt-1">
                Disclaimer: Loans are subject to approval and terms & conditions. Borrow responsibly.
              </p>
            </div>

            {/* Social Links */}
            <div className="flex gap-4">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 cursor-default">
                <FaLinkedin className="text-xl" />
              </div>
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 cursor-default">
                <FaFacebook className="text-xl" />
              </div>
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 cursor-default">
                <FaTwitter className="text-xl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
